import { useState } from 'react'
import { Box, List, ListItemButton, ListItemText } from '@mui/material'
import { EmailCaptureWidget } from './EmailCaptureWidget'
import { WordPressDealFeed } from './WordPressDealFeed'
import { ArticleRSSFeed } from './ArticleRSSFeed'

const styles = {
  container: {
    display: 'flex',
    minHeight: '100vh',
    padding: '20px'
  },
  sidebar: {
    width: 240,
    minWidth: 240,
    maxWidth: 240,
    borderRight: 1,
    borderColor: 'divider',
    overflow: 'hidden',
    flexShrink: 0
  },
  content: {
    flexGrow: 1,
    pl: 3,
    pr: 3,
    pb: 3,
    pt: 0,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0
  },
  listItemText: (isSelected: boolean) => ({
    color: isSelected ? 'primary' : 'inherit',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block'
  })
}

export const PublisherResources = () => {
  const [selectedResource, setSelectedResource] = useState('email')

  const resources = [
    { id: 'email', label: 'Email Capture Widget' },
    { id: 'wordpress', label: 'WordPress Deal Feed' },
    { id: 'article', label: 'Article RSS Feed' }
  ]
  const renderContent = () => {
    switch (selectedResource) {
      case 'email':
        return <EmailCaptureWidget />
      case 'wordpress':
        return <WordPressDealFeed />
      case 'article':
        return <ArticleRSSFeed />
      default:
        return <EmailCaptureWidget />
    }
  }

  return (
    <Box sx={styles.container}>
      <Box sx={styles.sidebar}>
        <List component="nav">
          {resources.map((resource) => (
            <ListItemButton
              key={resource.id}
              selected={selectedResource === resource.id}
              onClick={() => setSelectedResource(resource.id)}
            >
              <ListItemText
                primary={resource.label}
                primaryTypographyProps={styles.listItemText(
                  selectedResource === resource.id
                )}
              />
            </ListItemButton>
          ))}
        </List>
      </Box>

      <Box sx={styles.content}>{renderContent()}</Box>
    </Box>
  )
}
